export const fetchLogCodes = () => (
  {
    type: 'FETCH_LOG_CODES',
  }
)

export const fetchLogProviders = () => (
  {
    type: 'FETCH_LOG_PROVIDERS',
  }
)

export const addLogProvider = (data) => (
  {
    type: 'ADD_LOG_PROVIDER',
    fromCode: data.fromCode,
    toCode: data.toCode,
    provider: data.provider,
    section: data.section,
    description: data.description
  }
)

export const updateLogProvider = (data) => (
  {
    type: 'UPDATE_LOG_PROVIDER',
    id: data.id,
    provider: data.provider,
    section: data.section,
    description: data.description
  }
)

export const addCode = (data) => (
  {
    type: 'ADD_LOG_CODE',
    code: data.code,
    description: data.description
  }
)

export const updateCode = (data) => (
  {
    type: 'UPDATE_LOG_CODE',
    code: data.code,
    description: data.description
  }
)